<template>
  <footer>
    <h6 class="content text-center">
      Created especially for you by
      <strong>
        <a target="_blank" href="https://www.titusdecali.com" rel="noopener"
          >Titus Decali</a
        >
      </strong>
    </h6>
  </footer>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
footer {
  margin-top: 100px;
  font-weight: light !important;
  background: $footer;
  padding: 10px 20px;
  color: $grey-light;
}
a {
  color: white;
  font-weight: 700;
  &:hover {
    color: $yellow;
  }
}
</style>
